import { useEffect, useState } from "react";
import { fetchServiceJson } from "../../../services/common.services";
import { validateAndEnsureArray } from "../../../utils/jsonValidator";

const INITIAL_OPTIONS = {
    categories: [],
    sublines: [],
    units: [],
    lines: [],
    brands: [],
    references: [],
    ansList: [],
};

const FIELD_MAP = {
    category: "categories",
    lines: "lines",
    sublines: "sublines",
    ans: "ansList",
    brand: "brands",
    references: "references",
    unitMeasuremen: "units",
};

export const useFormOptions = (idCompany, token) => {
    const [options, setOptions] = useState(INITIAL_OPTIONS);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!idCompany) return;

        const fetchOptions = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetchServiceJson("MENU-PRODUCT_SERVICE", token, idCompany);
                if (!response.data?.length) return;

                const parsed = response.data.reduce((acc, item) => {
                    const key = FIELD_MAP[item.field];
                    if (key) acc[key] = validateAndEnsureArray(item.value);
                    return acc;
                }, {});

                setOptions((prev) => ({ ...prev, ...parsed }));
            } catch (e) {
                console.error("Error fetching form options:", e.message);
                setError(e.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOptions();
    }, [idCompany, token]);

    return { options, loading, error };
};